import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';

interface Props {
  children: React.ReactNode;
  highlight?: boolean;
  onAnimationComplete?: () => void;
}

export const AnimWrapper = ({ children, highlight = false, onAnimationComplete }: Props) => {
  if (!highlight) {
    return <>{children}</>;
  }

  return (
    <motion.div
      css={[{ width: '100%' }, highlight && highlightAnimation]}
      animate={highlight && { backgroundColor: animColors }}
      transition={{ duration: 3, ease: 'easeInOut', times: [0, 0.5, 1] }}
      onAnimationComplete={onAnimationComplete}
    >
      {children}
    </motion.div>
  );
};

const animColors = [theme.colors.white, theme.colors.tangerine10, theme.colors.white];

const highlightAnimation = css({
  animation: 'heightAnimation 1s ease-in-out',
  '@keyframes heightAnimation': {
    '0%': {
      opacity: 0,
      maxHeight: 1, // NOTE: keeping this 1 instead of 0 to avoid virtualized list issues
      transform: 'scale(0.95)',
      overflow: 'hidden',
    },
    '100%': {
      opacity: 1,
      maxHeight: 150,
      transform: 'scale(1)',
    },
  },
});
